import profile from './profile';
import type from './type';
import idx from './idx';

const state = {
    idxCheckEnabled: true,
};

const getters = {
    isIdxFlow(state, getters, rootState) {
        const type = state.type.legalType || rootState.users.getUserProfileResult?.legalType;
        return state.idxCheckEnabled && (type === 'F' || type === 'I');
    },
};

const mutations = {};

const actions = {};

const modules = {
    profile,
    type,
    idx,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules,
};
